import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, extractError } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (err) {
            toast.error(extractError(err));
        } finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-6 auth-grid-bg">
            <div className="w-full max-w-md brut-section p-10" data-testid="forgot-card">
                <div className="label-overline mb-2">Recovery</div>
                <h1 className="text-3xl font-bold tracking-tight mb-2">Reset your password</h1>
                <p className="text-sm text-muted-foreground mb-8">We'll send a recovery link to your email.</p>
                {sent ? (
                    <div className="border border-border p-6 bg-secondary rounded-sm" data-testid="forgot-sent">
                        <div className="label-overline mb-2">Check your inbox</div>
                        <p className="text-sm">If that email exists, a reset link has been sent. The link expires in 1 hour.</p>
                    </div>
                ) : (
                    <form onSubmit={onSubmit} className="space-y-5">
                        <div>
                            <Label className="label-overline">Email</Label>
                            <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 rounded-sm h-11" data-testid="forgot-email-input" />
                        </div>
                        <Button type="submit" disabled={loading} className="w-full rounded-sm h-11 bg-primary hover:bg-primary/90 text-primary-foreground" data-testid="forgot-submit-button">
                            {loading ? "Sending..." : "Send recovery link"}
                        </Button>
                    </form>
                )}
                <div className="mt-8 pt-6 border-t border-border text-sm">
                    <Link to="/login" className="text-primary hover:underline">← Back to sign in</Link>
                </div>
            </div>
        </div>
    );
}
